module.exports = __webpack_public_path__ + "static/media/mech.413a2de6.jpg";